import Vue from 'vue'
import { prettifyErrorMessage } from '../utils';

export function showToast({status, data}, onlyError = false) {
    const {message} = data;
    if (!onlyError) {
        if (status >= 200 && status < 304) {
            Vue.notify({
                group: 'appNotif',
                title: 'Success',
                text: message,
                type: 'success'
            })
        }
    }

    if (status === 403) {
        Vue.notify({
            group: 'appNotif',
            title: 'Authentication Error',
            text: 'Please relogin your current user connection!',
            type: 'error'
        })
        // store.dispatch('appLogout')
        // window.location = "/app/login"
    }
    
    if (status >= 400 && status < 500 && status !== 403) {
        Vue.notify({
            group: 'appNotif',
            title: 'Fail',
            text: prettifyErrorMessage(message),
            type: 'warn'
        }) 
    }
    
    if (status >= 500 && status < 600) {
        Vue.notify({
            group: 'appNotif',
            title: 'Internal Server Error',
            text: message,
            type: 'error'
        }) 
    }
}